import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=186d40b7&scoped=true&"
import script from "./setPrice.vue?vue&type=script&lang=js&"
export * from "./setPrice.vue?vue&type=script&lang=js&"
import style0 from "./setPrice.vue?vue&type=style&index=0&id=186d40b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d40b7",
  null
  
)

export default component.exports